import React, { useState, useEffect } from "react";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import InfoDetail from "./InfoDetail";
import { useIntl } from "react-intl";
import { getFullName } from "../../../util/helpers";
import { useGenders } from "../../../../hooks";
import moment from "moment";

const { Panel } = Collapse;

const Personal = (props) => {
  const { record } = props;
  const [gender, setGender] = useState(null);
  const intl = useIntl();
  const genders = useGenders();
  useEffect(() => {
    const selected = genders
      ? genders.filter((item) => item.id === record.gender_id)[0]
      : null;
    if (selected) {
      setGender(selected["name"]);
    }
  }, [genders, record]);

  let age = null;
  if (record.birthday) {
    var today = new Date();
    var birthDate = new Date(record.birthday);
    var result = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      result--;
    }
    age = result;
  }

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={["1"]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      className="custom-collapse-section"
    >
      <Panel
        header={intl.formatMessage({
          id: "app.leads.personal_details",
        })}
        key={"1"}
      >
        <div>
          <InfoDetail
            title={intl.formatMessage({
              id: "app.leads.fullname",
            })}
            detail={getFullName(record.surename, record.first_name)}
          />
          {record.birthday && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.birthday",
              })}
              detail={moment(record.birthday).format("L")}
            />
          )}
          {age && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.age",
              })}
              detail={age}
            />
          )}
          {gender && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.gender",
              })}
              detail={intl.formatMessage({
                id: `app.dataSelect.gender_id.${gender}`,
              })}
            />
          )}
        </div>
      </Panel>
    </Collapse>
  );
};
export default Personal;
